import Application from '../../Application'

export default class File {
  private _path: string
  private _content?: Blob

  constructor(public readonly app: Application, path: string) {
    this._path = path
  }

  get path(): string {
    return this._path
  }

  get content(): Blob | void {
    return this._content
  }

  rename(newPath: string): Promise<this> {
    return this.app
      .client()
      .fs.fileRename(this.path, { newPath })
      .then(() => {
        this._path = newPath

        return Promise.resolve(this)
      })
  }

  delete(): Promise<this> {
    return this.app
      .client()
      .fs.fileDelete(this.path)
      .then(() => {
        this._content = undefined

        return Promise.resolve(this)
      })
  }

  sync(): Promise<this> {
    return this.app
      .client()
      .fs.fileDownload(this.path)
      .then((content) => {
        this._content = content

        return Promise.resolve(this)
      })
  }

  realSync(handler: (file: this) => void) {
    // todo
    handler(this)
  }

  upload(content: Blob): Promise<this> {
    return this.app
      .client()
      .fs.fileUpload(this.path, content)
      .then(() => {
        this._content = content

        return Promise.resolve(this)
      })
  }

  getContentText(): Promise<string> {
    if (this._content) {
      return new Promise((res) => {
        const reader = new FileReader()
        reader.addEventListener('loadend', function() {
          // reader.result contains the contents of blob as a typed array
          res(reader.result)
        })
        // todo clone this._content
        reader.readAsText(this._content || new Blob())
      })
    }

    return Promise.resolve('')
  }
}
